var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div ng-if=\"isWithinTimeRange()\" class=\"warning-notification\"> {{'NOTIFICATION.WARNING.SERVICE_UNAVAILABLE' | translate}} </div>";
ngModule.run(["$templateCache",function(c){c.put("warning-notification/templates/index.html",v1)}]);
module.exports=v1;


/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/warning-notification/templates/index.html
 ** module id = 582
 ** module chunks = 1
 **/